// extracted by mini-css-extract-plugin
export default {"root":"BorderContainer-module-root-NM5gV","fullWidth":"BorderContainer-module-fullWidth-DQGRm","borderHidden":"BorderContainer-module-borderHidden-lmqdz"};